/* SHREDDERS – Télésiège vu de haut, le long de la page (côté gauche)
   Commence sous la section où il est placé et descend jusqu'au bas du contenu.
   Quand on défile vers le bas, les chaises descendent plus vite que la page ;
   vers le haut, elles reculent à la même vitesse. Un seul câble (celui de droite).
   Rendu réaliste vu du ciel : neige damée en velours côtelé, traces de ski dans la poudreuse,
   sapins enneigés en étoile avec leur ombre, pylônes et chaises qui projettent leur ombre.
   Tout ce qui est détaillé est dessiné une fois dans des « sprites » ; chaque image ne fait
   que les recopier (léger, même en défilant vite). */
(function () {
  'use strict';

  var TEE_COLORS = ['#f4f4f6', '#b0cdee', '#edbdc8', '#604438', '#58595d', '#f3e2cb'];
  var SUN = { x: 0.62, y: 0.78 };              // les ombres partent vers le bas à droite

  function rnd(seed) {
    var s = (seed * 2654435761) % 2147483647; if (s <= 0) s += 2147483646;
    return function () { s = (s * 16807) % 2147483647; return (s - 1) / 2147483646; };
  }
  function mod(a, n) { return ((a % n) + n) % n; }
  function clamp(v, a, b) { return v < a ? a : v > b ? b : v; }
  function rr(g, x, y, w, h, r) {
    g.beginPath();
    g.moveTo(x + r, y); g.lineTo(x + w - r, y); g.quadraticCurveTo(x + w, y, x + w, y + r);
    g.lineTo(x + w, y + h - r); g.quadraticCurveTo(x + w, y + h, x + w - r, y + h);
    g.lineTo(x + r, y + h); g.quadraticCurveTo(x, y + h, x, y + h - r);
    g.lineTo(x, y + r); g.quadraticCurveTo(x, y, x + r, y); g.closePath();
  }
  function surface(w, h, dpr) {
    var c = document.createElement('canvas');
    c.width = Math.max(1, Math.ceil(w * dpr)); c.height = Math.max(1, Math.ceil(h * dpr));
    var x = c.getContext('2d'); x.setTransform(dpr, 0, 0, dpr, 0, 0);
    return { c: c, g: x, w: w, h: h };
  }

  // ---------- neige damée : velours côtelé en bandes de dameuse, bosses douces, paillettes ----------
  function snowTile(dpr, W) {
    var TW = Math.max(64, Math.ceil(W)), TH = 520;
    var S = surface(TW, TH, dpr), g = S.g, R = rnd(41);
    g.fillStyle = '#f2f6fa'; g.fillRect(0, 0, TW, TH);
    // ondulations très douces (lumière rasante) : bleuté dans les creux
    for (var i = 0; i < 26; i++) {
      var x = R() * TW, y = R() * TH, r = 40 + R() * 110, blue = R() < 0.55;
      for (var dy = -TH; dy <= TH; dy += TH) {      // raccord vertical
        var gr = g.createRadialGradient(x, y + dy, 0, x, y + dy, r);
        gr.addColorStop(0, blue ? 'rgba(160,184,212,0.16)' : 'rgba(255,255,255,0.7)');
        gr.addColorStop(1, 'rgba(255,255,255,0)');
        g.fillStyle = gr; g.fillRect(x - r, y + dy - r, r * 2, r * 2);
      }
    }
    // velours côtelé : stries fines dans le sens de la pente, par bandes de dameuse décalées
    var lane = 118, pitch = 3.4;
    for (var lx = -lane; lx < TW + lane; lx += lane) {
      var ph = R() * pitch, wob = R() * 6.28;
      for (var sx = lx + ph; sx < lx + lane; sx += pitch) {
        var a = 0.055 + 0.025 * Math.sin(sx * 0.7 + wob);
        g.fillStyle = 'rgba(126,152,184,' + a.toFixed(3) + ')'; g.fillRect(sx, 0, 1.05, TH);
        g.fillStyle = 'rgba(255,255,255,0.5)'; g.fillRect(sx + 1.3, 0, 0.8, TH);
      }
      // jointure entre deux passages de dameuse : petit bourrelet
      g.fillStyle = 'rgba(120,146,178,0.18)'; g.fillRect(lx + lane - 1.5, 0, 1.5, TH);
      g.fillStyle = 'rgba(255,255,255,0.9)'; g.fillRect(lx + lane, 0, 1.2, TH);
    }
    // paillettes de givre
    for (i = 0; i < TW * TH / 260; i++) {
      g.fillStyle = 'rgba(255,255,255,' + (0.5 + R() * 0.5).toFixed(2) + ')';
      g.fillRect(R() * TW, R() * TH, 0.9, 0.9);
    }
    return S;
  }

  // ---------- sapin vu du ciel : étoile de branches plumeuses, neige posée, ombre allongée ----------
  function treeSprite(r, seed, dpr) {
    var pad = r * 2.4, S = surface(r * 2 + pad * 1.6, r * 2 + pad * 1.6, dpr), g = S.g, R = rnd(seed);
    var cx = r + pad * 0.4, cy = r + pad * 0.4;
    S.ox = cx; S.oy = cy;
    // ombre portée : le sapin est un cône haut -> ombre longue dans le sens du soleil
    g.save();
    try { g.filter = 'blur(' + Math.max(1, r * 0.12).toFixed(1) + 'px)'; } catch (e) {}
    g.fillStyle = 'rgba(74,104,148,0.30)';
    g.beginPath();
    var L = r * 2.3, nx = -SUN.y, ny = SUN.x;
    g.moveTo(cx + nx * r * 0.85, cy + ny * r * 0.85);
    g.quadraticCurveTo(cx + SUN.x * L * 0.55 + nx * r * 0.9, cy + SUN.y * L * 0.55 + ny * r * 0.9, cx + SUN.x * L, cy + SUN.y * L);
    g.quadraticCurveTo(cx + SUN.x * L * 0.55 - nx * r * 0.9, cy + SUN.y * L * 0.55 - ny * r * 0.9, cx - nx * r * 0.85, cy - ny * r * 0.85);
    g.closePath(); g.fill();
    g.restore();
    // étages de branches, du bas (large, sombre) vers le haut (petit, clair)
    var layers = [[1.0, '#16302a', 22], [0.82, '#1f3d33', 19], [0.62, '#2a4c3f', 15], [0.4, '#36604e', 11]];
    layers.forEach(function (Lr, li) {
      var rad = r * Lr[0], nb = Lr[2];
      for (var b = 0; b < nb; b++) {
        var a = (b + R() * 0.6) / nb * Math.PI * 2 + li * 0.37;
        var len = rad * (0.78 + R() * 0.3), wdt = rad * (0.2 + R() * 0.08);
        var ca = Math.cos(a), sa = Math.sin(a), px = -sa, py = ca;
        // côté au soleil plus clair, côté ombre plus sombre
        var lit = -(ca * SUN.x + sa * SUN.y);
        g.fillStyle = Lr[1];
        g.globalAlpha = 1;
        g.beginPath();
        g.moveTo(cx + px * wdt * 0.25, cy + py * wdt * 0.25);
        // bord dentelé : aiguilles
        var steps = 6;
        for (var k = 1; k <= steps; k++) {
          var t = k / steps, w = wdt * (1 - t * 0.85) * (k % 2 ? 1 : 0.62);
          g.lineTo(cx + ca * len * t + px * w, cy + sa * len * t + py * w);
        }
        g.lineTo(cx + ca * len * 1.04, cy + sa * len * 1.04);
        for (k = steps; k >= 1; k--) {
          var t2 = k / steps, w2 = wdt * (1 - t2 * 0.85) * (k % 2 ? 0.62 : 1);
          g.lineTo(cx + ca * len * t2 - px * w2, cy + sa * len * t2 - py * w2);
        }
        g.closePath(); g.fill();
        if (lit > 0.1) { g.fillStyle = 'rgba(120,170,140,' + (0.18 * lit).toFixed(3) + ')'; g.fill(); }
        else if (lit < -0.1) { g.fillStyle = 'rgba(5,15,20,' + (-0.28 * lit).toFixed(3) + ')'; g.fill(); }
        // nervure centrale
        g.strokeStyle = 'rgba(10,22,18,0.35)'; g.lineWidth = Math.max(0.4, r * 0.025);
        g.beginPath(); g.moveTo(cx, cy); g.lineTo(cx + ca * len * 0.92, cy + sa * len * 0.92); g.stroke();
        // neige posée sur la branche (plus sur le côté au soleil)
        if (R() < 0.75) {
          var t0 = 0.3 + R() * 0.4, sl = len * (0.18 + R() * 0.22);
          g.strokeStyle = 'rgba(246,250,255,' + (0.6 + 0.35 * Math.max(0, lit)).toFixed(2) + ')';
          g.lineCap = 'round'; g.lineWidth = Math.max(0.7, wdt * (0.35 + R() * 0.3));
          g.beginPath();
          g.moveTo(cx + ca * len * t0 - px * wdt * 0.1, cy + sa * len * t0 - py * wdt * 0.1);
          g.lineTo(cx + ca * (len * t0 + sl) - px * wdt * 0.1, cy + sa * (len * t0 + sl) - py * wdt * 0.1);
          g.stroke();
        }
      }
    });
    // cime enneigée
    g.fillStyle = 'rgba(248,251,255,0.95)';
    g.beginPath(); g.arc(cx - r * 0.04, cy - r * 0.04, r * 0.09, 0, Math.PI * 2); g.fill();
    return S;
  }

  // ---------- chaise 2 places vue du ciel (sans passagers) + son ombre floue ----------
  function chairSprite(s, accent, dpr) {
    var cw = 96 * s, ch = 40 * s, pad = 30 * s;
    var S = surface(cw + pad * 2, ch + pad * 2, dpr), g = S.g;
    var x0 = pad, y0 = pad;
    S.ox = pad + cw / 2; S.oy = pad + ch / 2;
    // dossier (côté amont = en haut) : on voit son arête supérieure, tube + coussin
    var tube = '#8e98a3', tubeHi = '#d4dae1';
    g.fillStyle = '#20252c'; rr(g, x0 + 2 * s, y0 - 2 * s, cw - 4 * s, 9 * s, 3.5 * s); g.fill();
    g.fillStyle = accent; rr(g, x0 + 4 * s, y0 - 0.5 * s, cw - 8 * s, 3 * s, 1.5 * s); g.fill();
    // assise : deux coussins rembourrés avec couture
    [0, 1].forEach(function (k) {
      var sx = x0 + 3 * s + k * (cw / 2 - 1.5 * s), sw = cw / 2 - 4.5 * s, sy2 = y0 + 8 * s, sh2 = ch - 14 * s;
      var gr = g.createLinearGradient(0, sy2, 0, sy2 + sh2);
      gr.addColorStop(0, '#3c4450'); gr.addColorStop(0.5, '#323944'); gr.addColorStop(1, '#262c35');
      g.fillStyle = gr; rr(g, sx, sy2, sw, sh2, 5 * s); g.fill();
      g.strokeStyle = 'rgba(255,255,255,0.08)'; g.lineWidth = Math.max(0.5, 0.8 * s);
      rr(g, sx + 2 * s, sy2 + 2 * s, sw - 4 * s, sh2 - 4 * s, 3.5 * s); g.stroke();
    });
    // cadre tubulaire autour de l'assise
    g.strokeStyle = tube; g.lineWidth = Math.max(1, 2.6 * s);
    rr(g, x0, y0 + 6 * s, cw, ch - 10 * s, 6 * s); g.stroke();
    g.strokeStyle = tubeHi; g.lineWidth = Math.max(0.5, 0.9 * s);
    g.beginPath(); g.moveTo(x0 + 6 * s, y0 + 5.4 * s); g.lineTo(x0 + cw - 6 * s, y0 + 5.4 * s); g.stroke();
    // garde-corps rabattu + repose-pieds (côté aval = en bas)
    g.strokeStyle = tube; g.lineWidth = Math.max(1, 2.2 * s);
    g.beginPath(); g.moveTo(x0 + 6 * s, y0 + ch - 4 * s); g.lineTo(x0 + 6 * s, y0 + ch + 9 * s); g.lineTo(x0 + cw - 6 * s, y0 + ch + 9 * s); g.lineTo(x0 + cw - 6 * s, y0 + ch - 4 * s); g.stroke();
    g.strokeStyle = tubeHi; g.lineWidth = Math.max(0.5, 0.8 * s);
    g.beginPath(); g.moveTo(x0 + 8 * s, y0 + ch + 8.3 * s); g.lineTo(x0 + cw - 8 * s, y0 + ch + 8.3 * s); g.stroke();
    g.fillStyle = '#2a2f37';
    rr(g, x0 + cw * 0.16, y0 + ch + 11 * s, cw * 0.24, 4 * s, 2 * s); g.fill();
    rr(g, x0 + cw * 0.6, y0 + ch + 11 * s, cw * 0.24, 4 * s, 2 * s); g.fill();
    // ombre : la chaise est ~8 m au-dessus de la neige -> ombre décalée et floue
    var sh = surface(cw + pad * 2, ch + pad * 2, dpr);
    sh.ox = S.ox; sh.oy = S.oy;
    try { sh.g.filter = 'blur(' + Math.max(1, 3 * s).toFixed(1) + 'px)'; } catch (e) {}
    sh.g.fillStyle = 'rgba(64,92,132,0.28)';
    rr(sh.g, x0, y0 - 2 * s, cw, ch + 14 * s, 7 * s); sh.g.fill();
    S.shadow = sh;
    return S;
  }

  // ---------- pinces débrayables + bras (vus du dessus) ----------
  function drawGrip(g, x, y, s, accent) {
    g.fillStyle = 'rgba(0,0,0,0.25)'; rr(g, x - 7 * s + 1, y - 13 * s + 1.5, 14 * s, 26 * s, 3.5 * s); g.fill();
    var gr = g.createLinearGradient(x - 7 * s, 0, x + 7 * s, 0);
    gr.addColorStop(0, '#1b1f25'); gr.addColorStop(0.45, '#3a414b'); gr.addColorStop(1, '#16191e');
    g.fillStyle = gr; rr(g, x - 7 * s, y - 13 * s, 14 * s, 26 * s, 3.5 * s); g.fill();
    // galets
    g.fillStyle = '#9aa3ad';
    [-7, 7].forEach(function (dy) { [-1, 1].forEach(function (sd) { g.beginPath(); g.ellipse(x + sd * 7.5 * s, y + dy * s, 2 * s, 4.2 * s, 0, 0, Math.PI * 2); g.fill(); }); });
    g.fillStyle = accent; g.fillRect(x - 7 * s, y - 2 * s, 14 * s, 4 * s);
    g.fillStyle = 'rgba(255,255,255,0.35)'; g.fillRect(x - 5 * s, y - 12 * s, 2 * s, 24 * s);
  }

  // ---------- t-shirt posé sur le siège (vu du ciel) ----------
  function teeShape(g, x, y, w, color) {
    var h = w * 0.95;
    g.save(); g.translate(x, y);
    g.fillStyle = 'rgba(0,0,0,0.25)';
    g.beginPath(); g.ellipse(w * 0.05, h * 0.08, w * 0.42, h * 0.45, 0, 0, Math.PI * 2); g.fill();
    g.fillStyle = color;
    g.strokeStyle = 'rgba(11,11,13,0.25)'; g.lineWidth = Math.max(0.6, w * 0.03);
    g.beginPath();
    g.moveTo(-w * 0.18, -h / 2); g.quadraticCurveTo(0, -h * 0.36, w * 0.18, -h / 2);
    g.lineTo(w * 0.5, -h * 0.3); g.lineTo(w * 0.36, -h * 0.08); g.lineTo(w * 0.28, -h * 0.16);
    g.lineTo(w * 0.28, h / 2); g.lineTo(-w * 0.28, h / 2); g.lineTo(-w * 0.28, -h * 0.16);
    g.lineTo(-w * 0.36, -h * 0.08); g.lineTo(-w * 0.5, -h * 0.3); g.closePath();
    g.fill(); g.stroke();
    // plis + ombrage doux
    var sg = g.createLinearGradient(-w * 0.3, -h / 2, w * 0.3, h / 2);
    sg.addColorStop(0, 'rgba(255,255,255,0.18)'); sg.addColorStop(1, 'rgba(0,0,0,0.12)');
    g.fillStyle = sg; g.fill();
    g.strokeStyle = 'rgba(0,0,0,0.1)'; g.lineWidth = Math.max(0.5, w * 0.025);
    g.beginPath(); g.moveTo(-w * 0.12, h * 0.1); g.quadraticCurveTo(0, h * 0.2, w * 0.15, h * 0.32); g.stroke();
    g.fillStyle = 'rgba(11,11,13,0.55)';
    g.fillRect(-w * 0.14, -h * 0.08, w * 0.28, h * 0.05);
    g.fillRect(-w * 0.1, h * 0.02, w * 0.2, h * 0.04);
    g.restore();
  }

  function init(el) {
    if (el._shrRail) return;
    el._shrRail = true;
    var cv = el.querySelector('canvas');
    if (!cv || !cv.getContext) return;
    var g = cv.getContext('2d');
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var speed = parseFloat(el.getAttribute('data-speed')) || 1.6;
    var accent = el.getAttribute('data-accent') || '#e0642b';
    var withTees = el.getAttribute('data-tees') !== 'false';
    var sec = el.closest('.shopify-section') || el.parentNode;
    var W = 0, H = 0, dpr = 1, startY = 0, endY = 0, s = 1;
    var off = 0, offT = 0, vel = 0, last = 0, raf = 0;
    var snowPat = null, trees = [], chairSp = null, ropePat = null, builtFor = '';

    function build() {
      var key = W + 'x' + dpr;
      if (key === builtFor) return;
      builtFor = key;
      var tile = snowTile(dpr, W);
      snowPat = g.createPattern(tile.c, 'repeat');
      try { snowPat.setTransform(new DOMMatrix().scale(1 / dpr)); } catch (e) {}
      trees = [];
      var tr = Math.max(6, 22 * Math.max(0.6, s));
      for (var i = 0; i < 9; i++) trees.push(treeSprite(tr * (0.8 + (i % 3) * 0.2), 101 + i * 17, dpr));
      chairSp = chairSprite(s, accent, dpr);
      // câble d'acier toronné : motif diagonal qui défile avec la page
      var rp = surface(8, 8, dpr), rg = rp.g;
      rg.fillStyle = '#2a2f36'; rg.fillRect(0, 0, 8, 8);
      rg.strokeStyle = '#8d97a2'; rg.lineWidth = 1.6;
      for (var k = -2; k < 3; k++) { rg.beginPath(); rg.moveTo(k * 4 - 1, 9); rg.lineTo(k * 4 + 9, -1); rg.stroke(); }
      rg.strokeStyle = 'rgba(220,226,232,0.7)'; rg.lineWidth = 0.6;
      for (k = -2; k < 3; k++) { rg.beginPath(); rg.moveTo(k * 4 - 1.5, 9); rg.lineTo(k * 4 + 8.5, -1); rg.stroke(); }
      ropePat = g.createPattern(rp.c, 'repeat');
      try { ropePat.setTransform(new DOMMatrix().scale(1 / dpr)); } catch (e) {}
    }

    function measure() {
      W = el.clientWidth; H = window.innerHeight;
      dpr = Math.min(window.devicePixelRatio || 1, 2);
      cv.width = Math.max(1, Math.round(W * dpr)); cv.height = Math.max(1, Math.round(H * dpr));
      cv.style.width = W + 'px'; cv.style.height = H + 'px';
      s = clamp(W / 300, 0.17, 1.25);
      var sy = window.scrollY || window.pageYOffset || 0;
      startY = sec.getBoundingClientRect().top + sy;
      var end = startY, sib = sec.nextElementSibling;
      while (sib) {
        if (sib.offsetParent !== null && sib.offsetHeight > 0) end = Math.max(end, sib.getBoundingClientRect().bottom + sy);
        sib = sib.nextElementSibling;
      }
      endY = end;
      if (W > 0) build();
      readPage();
      draw();
    }

    // couleur du fond de la page (pour les fondus du haut et du bas), relue quand la palette change
    var pageRGB = '243, 235, 223';
    function readPage() {
      try {
        var c = getComputedStyle(document.body).backgroundColor.match(/[\d.]+/g);
        if (c && c.length >= 3 && !(c.length === 4 && +c[3] === 0)) pageRGB = c[0] + ', ' + c[1] + ', ' + c[2];
      } catch (e) {}
    }
    document.addEventListener('shr:collection', function () { setTimeout(function () { readPage(); draw(); }, 750); readPage(); draw(); });
    function draw() {
      if (!W || !H) return;
      var sy = window.scrollY || window.pageYOffset || 0;
      g.setTransform(1, 0, 0, 1, 0, 0);
      g.clearRect(0, 0, cv.width, cv.height);
      if (endY - startY < 40 || sy + H < startY || sy > endY) return;
      g.setTransform(dpr, 0, 0, dpr, 0, -sy * dpr);
      var top = Math.max(startY, sy - 40), bot = Math.min(endY, sy + H + 40);
      g.save();
      g.beginPath(); g.rect(0, startY, W, endY - startY); g.clip();

      // neige damée (le motif est fixé à la page)
      g.fillStyle = snowPat || '#f2f6fa';
      g.fillRect(0, top, W, bot - top);

      // un seul câble, collé au bord gauche du site (juste assez de place pour la chaise)
      var cR = W < 90 ? W * 0.42 : 48 * s + 12;
      var wide = W > 90;

      // poudreuse hors-piste à droite : traces de ski (sillons ombrés + lèvre éclairée), sapins
      // traces de ski : longues courbes continues, qui apparaissent et s'effacent (sillon ombré + lèvre éclairée)
      if (wide) {
        var CH = 620, c0 = Math.floor((top - startY) / CH) - 1, c1 = Math.ceil((bot - startY) / CH);
        for (var cj = c0; cj <= c1; cj++) {
          for (var lane = 0; lane < 2; lane++) {
            var RT = rnd(cj * 13 + lane * 101 + 5);
            if (RT() > 0.62) continue;
            var cy0 = startY + cj * CH + RT() * 120, clen = 260 + RT() * 320;
            var xb = cR + 70 * s + RT() * Math.max(10, W - cR - 110 * s), amp = 10 + RT() * 16, ph = RT() * 6.28, fr = 30 + RT() * 14;
            var drift = (RT() - 0.5) * 50;
            for (var pass = 0; pass < 2; pass++) {
              var fg = g.createLinearGradient(0, cy0, 0, cy0 + clen), col = pass ? '255,255,255,' : '126,154,190,', A = pass ? 0.95 : 0.34;
              fg.addColorStop(0, 'rgba(' + col + '0)'); fg.addColorStop(0.2, 'rgba(' + col + A + ')');
              fg.addColorStop(0.8, 'rgba(' + col + A + ')'); fg.addColorStop(1, 'rgba(' + col + '0)');
              g.strokeStyle = fg; g.lineWidth = pass ? 0.9 : 1.9;
              g.beginPath();
              for (var tr = 0; tr < 2; tr++) {
                for (var yy = 0; yy <= clen; yy += 6) {
                  var xx = xb + tr * 4.2 + drift * yy / clen + Math.sin((cy0 + yy) / fr + ph) * amp - (pass ? 1.2 : 0);
                  yy ? g.lineTo(xx, cy0 + yy) : g.moveTo(xx, cy0 + yy);
                }
              }
              g.stroke();
            }
          }
        }
      }
      var band = 140, b0 = Math.floor((top - startY) / band) - 1, b1 = Math.ceil((bot - startY) / band) + 1;
      var treeList = [];
      for (var b = b0; b <= b1; b++) {
        var R = rnd(b * 7 + 3), by = startY + b * band;
        R(); R(); R(); R(); R(); R();
        var nt = wide ? 1 + Math.floor(R() * 3) : (R() < 0.5 ? 1 : 0);
        for (var t = 0; t < nt; t++) {
          var tx = wide ? cR + 74 * s + R() * Math.max(10, W - cR - 96 * s) : 0.92 * W;
          treeList.push([tx, by + R() * band, Math.floor(R() * trees.length), wide ? 0.85 + R() * 0.4 : 0.45 + R() * 0.15]);
        }
      }
      treeList.sort(function (A, B) { return A[1] - B[1]; });
      treeList.forEach(function (it) {
        var sp = trees[it[2]]; if (!sp) return;
        var k = it[3];
        g.drawImage(sp.c, it[0] - sp.ox * k, it[1] - sp.oy * k, sp.w * k, sp.h * k);
      });

      // pylônes (fixes dans la page) : ombre longue du fût, bras, train de galets
      var TS = 780, k0 = Math.floor((top - startY - 420) / TS) - 1, k1 = Math.ceil((bot - startY) / TS) + 1;
      var towers = [];
      for (var kk = k0; kk <= k1; kk++) {
        var ty = startY + 420 + kk * TS;
        if (ty < startY + 120 || ty > endY - 60) continue;
        towers.push(ty);
        // ombre portée du fût (il fait ~12 m) et du bras
        g.save();
        g.fillStyle = 'rgba(64,92,132,0.15)';
        g.translate(10 * s, ty + 6 * s);
        g.beginPath(); g.moveTo(4 * s, -4 * s); g.lineTo(4 * s + SUN.x * 150 * s, -4 * s + SUN.y * 150 * s); g.lineTo(-4 * s + SUN.x * 150 * s, 4 * s + SUN.y * 150 * s); g.lineTo(-4 * s, 4 * s); g.closePath(); g.fill();
        g.fillRect(SUN.x * 150 * s - 4 * s, SUN.y * 150 * s - 5 * s, cR + 20 * s, 9 * s);
        g.restore();
      }

      // chaises : leur ombre sur la neige d'abord
      var L = Math.max(1, endY - startY);
      var SP = Math.round(160 + 130 * Math.min(1, s));
      var N = Math.max(2, Math.ceil(L / SP) + 1), LL = N * SP;
      var swing = clamp(-vel * 0.012, -10, 10) * s;
      var items = [];
      for (var i = 0; i < N; i++) {
        var yd = startY + mod(i * SP + off, LL) - SP / 2;
        if (yd > top - 80 && yd < bot + 80) items.push([cR, yd, 1, i]);
      }
      // ombre du câble (décalée comme celle des chaises)
      g.strokeStyle = 'rgba(64,92,132,0.16)'; g.lineWidth = Math.max(1, 2.6 * s);
      g.beginPath(); g.moveTo(cR + 22 * s, top); g.lineTo(cR + 22 * s, bot); g.stroke();
      if (chairSp) items.forEach(function (it) {
        var sh = chairSp.shadow, yy2 = it[1] + swing;
        g.drawImage(sh.c, it[0] + 24 * s - sh.ox, yy2 + 30 * s - sh.oy, sh.w, sh.h);
      });

      // pylônes par-dessus leur ombre
      towers.forEach(function (ty) {
        var px0 = 2, px1 = cR + 26 * s;
        var gb = g.createLinearGradient(0, ty - 5 * s, 0, ty + 5 * s);
        gb.addColorStop(0, '#5b636e'); gb.addColorStop(0.5, '#3a414b'); gb.addColorStop(1, '#262b32');
        g.fillStyle = gb; g.fillRect(px0, ty - 5 * s, px1 - px0, 10 * s);
        // tête du fût (rond) avec échelle
        var gp = g.createRadialGradient(px0 + 12 * s, ty - 3 * s, 0, px0 + 13 * s, ty, 12 * s);
        gp.addColorStop(0, '#8a939e'); gp.addColorStop(1, '#3a414b');
        g.fillStyle = gp; g.beginPath(); g.arc(px0 + 13 * s, ty, 11 * s, 0, Math.PI * 2); g.fill();
        g.strokeStyle = 'rgba(20,24,30,0.5)'; g.lineWidth = Math.max(0.5, 1 * s); g.stroke();
        // balancier de galets sous le câble
        g.fillStyle = '#23272e'; rr(g, cR - 8 * s, ty - 30 * s, 16 * s, 60 * s, 4 * s); g.fill();
        g.fillStyle = accent; g.fillRect(cR - 8 * s, ty - 1.5 * s, 16 * s, 3 * s);
        for (var w2 = -2; w2 <= 2; w2++) {
          var gy = ty + w2 * 11 * s;
          var gw = g.createRadialGradient(cR - 1 * s, gy - 1 * s, 0, cR, gy, 5 * s);
          gw.addColorStop(0, '#e2e7ec'); gw.addColorStop(1, '#7c8590');
          g.fillStyle = gw; g.beginPath(); g.ellipse(cR, gy, 3.6 * s, 4.6 * s, 0, 0, Math.PI * 2); g.fill();
        }
      });

      // chaises + passagers (des chandails SHREDDERS)
      items.forEach(function (it) {
        var x = it[0], y = it[1] + swing, idx = it[3];
        if (chairSp) g.drawImage(chairSp.c, x - chairSp.ox, y - chairSp.oy, chairSp.w, chairSp.h);
        var cw = 96 * s;
        if (withTees && idx % 3 !== 2) {
          teeShape(g, x - cw * 0.24, y + 2 * s, 30 * s, TEE_COLORS[idx % TEE_COLORS.length]);
          if (idx % 2 === 0) teeShape(g, x + cw * 0.24, y + 2 * s, 30 * s, TEE_COLORS[(idx + 3) % TEE_COLORS.length]);
        }
        // bras : de la pince (sur le câble) au dossier de la chaise
        g.strokeStyle = '#7f8994'; g.lineWidth = Math.max(1, 3 * s); g.lineCap = 'round';
        g.beginPath(); g.moveTo(x, it[1]); g.quadraticCurveTo(x + 6 * s, (it[1] + y) / 2 - 14 * s, x, y - 18 * s); g.stroke();
        g.strokeStyle = 'rgba(230,236,242,0.6)'; g.lineWidth = Math.max(0.5, 1 * s);
        g.beginPath(); g.moveTo(x - 1 * s, it[1]); g.quadraticCurveTo(x + 5 * s, (it[1] + y) / 2 - 14 * s, x - 1 * s, y - 18 * s); g.stroke();
      });

      // câble d'acier toronné par-dessus (on regarde d'en haut)
      var rw = Math.max(1.4, 3.6 * s);
      g.fillStyle = ropePat || '#2b3038';
      g.fillRect(cR - rw / 2, top, rw, bot - top);
      var hl = g.createLinearGradient(cR - rw / 2, 0, cR + rw / 2, 0);
      hl.addColorStop(0, 'rgba(255,255,255,0.28)'); hl.addColorStop(0.4, 'rgba(255,255,255,0)'); hl.addColorStop(1, 'rgba(0,0,0,0.35)');
      g.fillStyle = hl; g.fillRect(cR - rw / 2, top, rw, bot - top);
      items.forEach(function (it) { drawGrip(g, it[0], it[1], s, accent); });

      // entrée / sortie en fondu + bord droit
      var fade = 70;
      var f1 = g.createLinearGradient(0, startY, 0, startY + fade);
      f1.addColorStop(0, 'rgba(' + pageRGB + ',1)'); f1.addColorStop(1, 'rgba(' + pageRGB + ',0)');
      g.fillStyle = f1; g.fillRect(0, startY, W, fade);
      var f2 = g.createLinearGradient(0, endY - fade, 0, endY);
      f2.addColorStop(0, 'rgba(' + pageRGB + ',0)'); f2.addColorStop(1, 'rgba(' + pageRGB + ',1)');
      g.fillStyle = f2; g.fillRect(0, endY - fade, W, fade);
      var eg = g.createLinearGradient(W - 18, 0, W, 0);
      eg.addColorStop(0, 'rgba(42, 26, 16,0)'); eg.addColorStop(1, 'rgba(42, 26, 16,0.09)');
      g.fillStyle = eg; g.fillRect(W - 18, top, 18, bot - top);
      g.restore();
    }

    function frame(now) {
      raf = 0;
      var dt = last ? Math.min(0.05, (now - last) / 1000) : 1 / 60;
      last = now;
      var sy = window.scrollY || window.pageYOffset || 0;
      offT = reduce ? 0 : sy * speed;
      var prev = off;
      off += (offT - off) * (1 - Math.exp(-dt * 7));
      if (Math.abs(offT - off) < 0.3) off = offT;
      vel = (off - prev) / dt * 0.5 + vel * 0.5;
      draw();
      if (Math.abs(offT - off) > 0.01 || Math.abs(vel) > 1) raf = requestAnimationFrame(frame);
      else { vel = 0; last = 0; draw(); }
    }
    function kick() { if (!raf) raf = requestAnimationFrame(frame); }

    window.addEventListener('scroll', kick, { passive: true });
    var rs = 0;
    function onResize() { clearTimeout(rs); rs = setTimeout(function () { measure(); kick(); }, 80); }
    window.addEventListener('resize', onResize);
    if ('ResizeObserver' in window) new ResizeObserver(onResize).observe(document.body);
    window.addEventListener('load', onResize);
    off = offT = reduce ? 0 : (window.scrollY || 0) * speed;
    measure();
  }

  function boot(scope) { [].forEach.call((scope || document).querySelectorAll('[data-shr-rail]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
